import { render } from "./DetailMissionaVailder.vue?vue&type=template&id=24a76b60&scoped=true"
import script from "./DetailMissionaVailder.vue?vue&type=script&lang=js"
export * from "./DetailMissionaVailder.vue?vue&type=script&lang=js"

import "./DetailMissionaVailder.vue?vue&type=style&index=0&id=24a76b60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a76b60"]])

export default __exports__